import FieldPopover_Picker from "../../popover/render/picker"

const debug = false
// const debug = "FieldIconWithColor_Picker"

export default class FieldIconWithColor_Picker extends FieldPopover_Picker {

    onValueChange = (value:any) => {
        debug && console.log(debug, 'onValueChange', value)

        this.previousValue = this.state.currentValue
        const newValue = value

        this.setState({
            currentValue: newValue
        }, () => {
            if (this.props.onChange) this.props.onChange(newValue, this.onCancelChange)
        })
    }
}


